import { Directive, ElementRef, Renderer2, AfterViewInit, input } from '@angular/core';

@Directive({
  selector: '[appPositionRelative]'
})
export class PositionRelativeDirective implements AfterViewInit {
  targetId = input.required<string>();

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

  ngAfterViewInit(): void {
    setTimeout(() => {
      const targetElement = document.getElementById(this.targetId());
      if (targetElement) {
        const targetRect = targetElement.getBoundingClientRect();
        this.renderer.setStyle(this.el.nativeElement, 'top', `${targetRect.top}px`);
      }
    });
  }
}
